import { render, staticRenderFns } from "./DesktopFullscreen.vue?vue&type=template&id=59ca1d84&"
import script from "./DesktopFullscreen.vue?vue&type=script&lang=js&"
export * from "./DesktopFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports